import React from 'react';
import '../less/globus.less';
import '../less/transfers.less';
import globus_banner_img from '../img/globus_banner_img.png';
import attention_icon from '../img/wu/attention_icon.svg';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import { ReactSVG } from 'react-svg';
import { globus, transfersAttentionUrl } from "../../../../../services/urls/urls";
import requisitesItems from '../enums/globus/requisites_items.json';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
  const page = 'globus';

  const hero_data = {
    title: 'GLOBUS_BANNER_TITLE',
    text: 'GLOBUS_BANNER_TEXT',
    link: {
      text: "Оберіть зручний для себе пункт обслуговування системи",
      onClick: () => window.open(globus, "_blank"),
    }
  };

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="globus-new">
      <Hero
        data={hero_data}
        img={globus_banner_img}
        className="transfers"
        page={page}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <div className="get-requisites">
              <div className="container">
                <h2 className="get-requisites__title">{this.l10n('GLOBUS_USAGE_TITLE')}</h2>
                <div className="get-requisites__body">
                  {requisitesItems.map(({ title, text }, index) => (
                    <div key={index} className="get-requisites__item item-get-requisites">
                      <div className="item-get-requisites__title">{this.l10n(title)}</div>
                      <div className="item-get-requisites__text">{this.l10n(text)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="first-info-block">
              <InfoBlock
                text="GLOBUS_HOW_TO_BLOCK_TITLE_01"
              />
            </div>
            <InfoBlock
              text="GLOBUS_HOW_TO_BLOCK_TITLE_02"
            />
            <div className="first-info-block">
              <InfoBlock
                text="GLOBUS_HOW_TO_BLOCK_TITLE_03"
              />
            </div>
            <div className="attention-block">
              <div className="container">
                <div className="attention-block__body">
                  <div className="attention-block__title">
                    <ReactSVG src={attention_icon} className="attention-block__icon"/>
                    {this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TITLE')}
                  </div>
                  <div className="attention-block__text">
                    <ul>
                      <li>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_01')}</li>
                      <li>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_02')}</li>
                      <li>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_03')}</li>
                      <li>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_04')}</li>
                      <li>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_05')}</li>
                      <li>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_06')}</li>
                      <li>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_07')}</li>
                      <li>
                        {this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_08_1')}
                        <a href={transfersAttentionUrl} target='_blank' rel='noopener noreferrer'>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_08_2')}</a>
                      </li>
                    </ul>
                    <p>
                      {this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_09')}
                      <a href="/about/general" target='_self' onClick={(e) => this.navigate("/about/general", e)}>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_LINK_01')}</a>
                    </p>
                    <p>
                      {this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_TEXT_10')}
                      <a href="/forpartners" target='_self' onClick={(e) => this.navigate("/forpartners", e)}>{this.l10n('GLOBUS_NEW_ATTENTION_BLOCK_LINK_02')}</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'FAQ_SHORT_NEW_TITLE'}
              page={page}
            />
          </>
        ) : (
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        )}
      </div>
    </div>
  );
}